var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Help = function Help(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 15 15' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'Imported Layers'
      ),
      React.createElement('path', { d: 'M7.5 15C3.364 15 0 11.636 0 7.5S3.364 0 7.5 0 15 3.364 15 7.5 11.636 15 7.5 15zm0-14A6.508 6.508 0 0 0 1 7.5C1 11.084 3.916 14 7.5 14S14 11.084 14 7.5 11.084 1 7.5 1zm2.171 5.802a2.78 2.78 0 0 1-.33.444c-.124.136-.25.268-.378.396-.128.12-.254.242-.378.366a3.143 3.143 0 0 0-.336.396c-.1.14-.252.294-.312.462-.06.168-.163.352-.163.552v.556h-1v-.652c0-.248.097-.469.165-.66.068-.192.185-.368.289-.528a2.92 2.92 0 0 1 .364-.438c.128-.133.259-.259.379-.378.12-.12.242-.24.358-.36.116-.12.222-.25.314-.39s.165-.296.217-.468c.052-.172.07-.37.054-.594-.031-.44-.173-.784-.425-1.032s-.594-.372-1.026-.372c-.288 0-.536.052-.744.156a1.534 1.534 0 0 0-.522.42c-.14.176-.242.331-.306.575-.064.244-.096.721-.096.721h-1.02c-.008 0 .05-.734.174-1.087.124-.351.302-.63.534-.891a2.36 2.36 0 0 1 .846-.592c.332-.144.71-.209 1.134-.209.368 0 .708.057 1.02.165.312.108.58.266.804.47.224.204.398.455.522.751s.186.636.186 1.02a2.269 2.269 0 0 1-.324 1.201zm-2.897 4.172h1v1h-1v-1z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Help;
//# sourceMappingURL=Help.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Help.js